// import axios from 'axios';
// import { BASE_URL } from '../constant-value';

// const api = axios.create({
//   baseURL: `${BASE_URL}`,
//   withCredentials: true // برای HttpOnly Cookie
// });

// api.interceptors.request.use(
//   (config) => {
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// api.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response?.status === 401) {
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

// export default api;




//---------------------------- NEW INTERCEPTOR 1------------------------

import axios from 'axios';
import { BASE_URL } from '../constant-value';

const api = axios.create({
  baseURL: `${BASE_URL}`,
  withCredentials: true
});

// Interceptor برای درخواست‌ها
api.interceptors.request.use(
  (config) => {
    // تشخیص FormData
    const isFormData = config.data instanceof FormData;
    
    // فقط برای JSONها Content-Type رو اضافه کن
    if (!isFormData && !config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    // ❌ هیچ Authorization header اضافه نکن!
    // کوکی HttpOnly خودش به طور خودکار ارسال میشه
    
    // برای دیباگ (اختیاری)
    if (process.env.NODE_ENV === 'development') {
      console.log(`📤 ${config.method?.toUpperCase()} ${config.url}`);
      console.log(`📤 Is FormData: ${isFormData}`);
    }
    
    return config;
  },
  (error) => {
    console.error('❌ خطا در ارسال درخواست:', error);
    return Promise.reject(error);
  }
);

// Interceptor برای پاسخ‌ها
api.interceptors.response.use(
  (response) => {
    // ❌ هیچ token رو ذخیره نکن!
    // کوکی HttpOnly توسط سرور مدیریت میشه
    
    // برای دیباگ (اختیاری)
    if (process.env.NODE_ENV === 'development') {
      console.log(`📥 ${response.status} ${response.config.url}`);
    }
    
    return response;
  },
  (error) => {
    const { response } = error;
    
    if (response?.status === 401) {
      // ❌ هیچ token رو پاک نکن چون توی localStorage نیست
      
      // فقط اگر در صفحه لاگین نیستیم، redirect کنیم
      if (!window.location.pathname.includes('/login')) {
        console.warn('🔒 دسترسی غیرمجاز - هدایت به لاگین');
        window.location.href = '/login';
      }
    }
    
    // مدیریت سایر خطاها
    if (response?.status === 400) {
      console.error('❌ خطای درخواست:', response.data);
    } else if (response?.status === 500) {
      console.error('🔥 خطای سرور');
    } else if (!response) {
      console.error('🌐 خطای شبکه - سرور در دسترس نیست');
    }
    
    return Promise.reject(error);
  }
);

export default api;




//---------------------------- NEW INTERCEPTOR 2------------------------

// import axios from 'axios';

// // تنظیمات
// const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://app.autoyad.ir';
// const DEFAULT_TIMEOUT = 30000; // 30 ثانیه
// const isDevelopment = process.env.NODE_ENV === 'development';

// // ایجاد axios instance
// const api = axios.create({
//   baseURL: BASE_URL,
//   withCredentials: true, // برای کوکی HttpOnly
//   timeout: DEFAULT_TIMEOUT,
//   headers: {
//     'Accept': 'application/json',
//     'X-Requested-With': 'XMLHttpRequest'
//   }
// });

// // ذخیره درخواست‌های در حال اجرا برای جلوگیری از duplicate
// const pendingRequests = new Map();
// const PENDING_TIMEOUT = 2000; // 2 ثانیه برای درخواست‌های مشابه

// // تولید کلید یکتا برای درخواست
// function generateRequestKey(config) {
//   const { method, url, params, data } = config;
  
//   // برای GETها پارامترها مهمه
//   if (method?.toLowerCase() === 'get') {
//     return `${method}_${url}_${JSON.stringify(params || {})}`;
//   }
  
//   // برای POST/PUT/PATCH داده مهمه (اما نه برای FormData بزرگ)
//   if (data instanceof FormData) {
//     return `${method}_${url}_formdata`;
//   }
  
//   return `${method}_${url}_${JSON.stringify(data || {})}`;
// }

// // حذف درخواست‌های قدیمی از pending
// function cleanupPendingRequests() {
//   const now = Date.now();
//   for (const [key, timestamp] of pendingRequests.entries()) {
//     if (now - timestamp > PENDING_TIMEOUT) {
//       pendingRequests.delete(key);
//     }
//   }
// }

// // ==================== REQUEST INTERCEPTOR ====================
// api.interceptors.request.use(
//   (config) => {
//     cleanupPendingRequests();
    
//     const requestKey = generateRequestKey(config);
//     const now = Date.now();
    
//     // جلوگیری از درخواست‌های تکراری سریع
//     if (pendingRequests.has(requestKey)) {
//       const lastRequestTime = pendingRequests.get(requestKey);
//       if (now - lastRequestTime < 1000) { // کمتر از 1 ثانیه
//         if (isDevelopment) {
//           console.warn(`⏳ درخواست تکراری لغو شد: ${requestKey}`);
//         }
//         return Promise.reject(new axios.Cancel('درخواست تکراری'));
//       }
//     }
    
//     pendingRequests.set(requestKey, now);
    
//     // ========== مدیریت Content-Type ==========
//     const isFormData = config.data instanceof FormData;
//     const isURLSearchParams = config.data instanceof URLSearchParams;
    
//     // حذف Content-Type پیش‌فرض برای FormData و URLSearchParams
//     if (isFormData || isURLSearchParams) {
//       delete config.headers['Content-Type']; // axios خودش تنظیم می‌کند
//     } 
//     // تنظیم Content-Type برای JSON اگر ست نشده
//     else if (!config.headers['Content-Type'] && config.data) {
//       config.headers['Content-Type'] = 'application/json';
//     }
    
//     // ========== اضافه کردن هدرهای اختصاصی ==========
//     // شناسه دستگاه/مرورگر (برای ردیابی)
//     if (!config.headers['X-Client-ID']) {
//       const clientId = localStorage.getItem('client_id') || 
//                        `web_${navigator.userAgent.substring(0, 50)}_${Date.now()}`;
//       localStorage.setItem('client_id', clientId);
//       config.headers['X-Client-ID'] = clientId;
//     }
    
//     // نسخه اپ (اگر در env تعریف شده)
//     if (process.env.REACT_APP_VERSION && !config.headers['X-App-Version']) {
//       config.headers['X-App-Version'] = process.env.REACT_APP_VERSION;
//     }
    
//     // ========== cache busting برای GETها ==========
//     if (config.method?.toLowerCase() === 'get') {
//       config.params = {
//         ...config.params,
//         _: Date.now() // timestamp برای جلوگیری از cache
//       };
//     }
    
//     // ========== لاگ در حالت توسعه ==========
//     if (isDevelopment) {
//       console.group(`📤 ${config.method?.toUpperCase()} ${config.url}`);
//       console.log('Config:', {
//         isFormData,
//         isURLSearchParams,
//         timeout: config.timeout,
//         headers: config.headers
//       });
//       if (!isFormData && config.data) {
//         console.log('Data:', config.data);
//       }
//       console.groupEnd();
//     }
    
//     return config;
//   },
//   (error) => {
//     console.error('❌ خطا در تنظیم درخواست:', error);
//     return Promise.reject(error);
//   }
// );

// // ==================== RESPONSE INTERCEPTOR ====================
// api.interceptors.response.use(
//   (response) => {
//     // حذف از pending requests
//     const requestKey = generateRequestKey(response.config);
//     pendingRequests.delete(requestKey);
    
//     // ========== لاگ در حالت توسعه ==========
//     if (isDevelopment) {
//       console.group(`📥 ${response.status} ${response.config.url}`);
//       console.log('Response:', {
//         status: response.status,
//         statusText: response.statusText,
//         data: response.data,
//         headers: response.headers
//       });
//       console.groupEnd();
//     }
    
//     // ========== پردازش پاسخ‌های خاص ==========
    
//     // اگر سرور می‌گوید لاگاوت کن (مثلاً برای تغییر رمز)
//     if (response.data?.forceLogout) {
//       handleForceLogout(response.data.message);
//       return Promise.reject(new Error('نیاز به ورود مجدد'));
//     }
    
//     // اگر سرور یک redirect می‌دهد
//     if (response.data?.redirectTo) {
//       setTimeout(() => {
//         window.location.href = response.data.redirectTo;
//       }, 100);
//     }
    
//     return response;
//   },
//   (error) => {
//     // حذف از pending requests
//     if (error.config) {
//       const requestKey = generateRequestKey(error.config);
//       pendingRequests.delete(requestKey);
//     }
    
//     // ========== مدیریت خطاها ==========
    
//     // درخواست لغو شده
//     if (axios.isCancel(error)) {
//       if (isDevelopment) {
//         console.log('🚫 درخواست لغو شد:', error.message);
//       }
//       return Promise.reject(error);
//     }
    
//     // خطای شبکه (سرور پاسخ نمی‌دهد)
//     if (!error.response) {
//       handleNetworkError(error);
//       return Promise.reject(new Error('اتصال به سرور برقرار نیست. لطفاً اینترنت خود را بررسی کنید.'));
//     }
    
//     const { status, data, headers } = error.response;
    
//     // ========== لاگ خطا ==========
//     if (isDevelopment) {
//       console.group(`❌ ${status} ${error.config?.url}`);
//       console.error('Error Response:', {
//         status,
//         data,
//         headers
//       });
//       console.groupEnd();
//     }
    
//     // ========== هندل کردن کدهای خطا ==========
//     switch (status) {
//       case 400:
//         handleBadRequest(data);
//         break;
        
//       case 401:
//         handleUnauthorized();
//         break;
        
//       case 403:
//         handleForbidden(data);
//         break;
        
//       case 404:
//         handleNotFound(error.config.url);
//         break;
        
//       case 408:
//       case 504:
//         handleTimeoutError();
//         break;
        
//       case 429:
//         handleRateLimit(headers);
//         break;
        
//       case 500:
//       case 502:
//       case 503:
//         handleServerError(status);
//         break;
        
//       default:
//         handleUnknownError(status, data);
//     }
    
//     return Promise.reject(error);
//   }
// );

// // ==================== HANDLER FUNCTIONS ====================

// function handleNetworkError(error) {
//   console.error('🌐 خطای شبکه:', error.message);
  
//   // نمایش notification به کاربر
//   if (typeof window.showNotification === 'function') {
//     window.showNotification('error', 'اتصال اینترنت خود را بررسی کنید');
//   } else {
//     // fallback
//     alert('⚠️ اتصال به سرور برقرار نیست. لطفاً اینترنت خود را بررسی کنید.');
//   }
// }

// function handleBadRequest(data) {
//   console.warn('⚠️ خطای درخواست:', data);
  
//   // نمایش validation errors
//   if (data?.errors) {
//     const errorMessages = Object.values(data.errors).flat().join('\n');
//     if (typeof window.showNotification === 'function') {
//       window.showNotification('warning', errorMessages);
//     }
//   }
// }

// function handleUnauthorized() {
//   console.warn('🔒 دسترسی غیرمجاز - کاربر لاگین نیست');
  
//   // فقط اگر در صفحه لاگین نیستیم
//   if (!window.location.pathname.includes('/login')) {
//     // ذخیره صفحه فعلی برای بازگشت بعد از لاگین
//     sessionStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);
    
//     // هدایت به لاگین
//     window.location.href = '/login';
//   }
// }

// function handleForbidden(data) {
//   console.warn('🚫 دسترسی ممنوع:', data?.message || 'شما مجوز دسترسی به این بخش را ندارید');
  
//   if (typeof window.showNotification === 'function') {
//     window.showNotification('error', data?.message || 'شما مجوز دسترسی به این بخش را ندارید');
//   }
// }

// function handleNotFound(url) {
//   console.warn('🔍 منبع یافت نشد:', url);
  
//   // فقط لاگ کن، معمولاً نیاز به action خاصی نیست
// }

// function handleTimeoutError() {
//   console.error('⏰ timeout - سرور پاسخ نمی‌دهد');
  
//   if (typeof window.showNotification === 'function') {
//     window.showNotification('warning', 'سرور در حال حاضر پاسخگو نیست. لطفاً مجدداً تلاش کنید.');
//   }
// }

// function handleRateLimit(headers) {
//   const retryAfter = headers['retry-after'] || 60;
//   console.warn(`🚫 محدودیت درخواست - لطفاً ${retryAfter} ثانیه دیگر تلاش کنید`);
  
//   if (typeof window.showNotification === 'function') {
//     window.showNotification('warning', `تعداد درخواست‌های شما زیاد است. لطفاً ${retryAfter} ثانیه دیگر تلاش کنید.`);
//   }
// }

// function handleServerError(statusCode) {
//   console.error(`🔥 خطای سرور (${statusCode})`);
  
//   if (typeof window.showNotification === 'function') {
//     window.showNotification('error', 'خطای سرور. لطفاً بعداً تلاش کنید.');
//   }
// }

// function handleUnknownError(status, data) {
//   console.error(`⚠️ خطای ناشناخته ${status}:`, data);
  
//   if (typeof window.showNotification === 'function') {
//     window.showNotification('error', `خطای ${status} - لطفاً با پشتیبانی تماس بگیرید.`);
//   }
// }

// function handleForceLogout(message) {
//   console.warn('🔒 اجباری برای خروج:', message);
  
//   // پاک کردن هر state محلی
//   localStorage.clear();
//   sessionStorage.clear();
  
//   // هدایت به لاگین با پیام
//   window.location.href = `/login?message=${encodeURIComponent(message)}`;
// }

// // ==================== UTILITY FUNCTIONS ====================

// /**
//  * بررسی آنلاین بودن کاربر
//  */
// api.isOnline = () => navigator.onLine;

// /**
//  * توقف درخواست‌های در حال انتظار
//  */
// api.cancelPendingRequests = () => {
//   pendingRequests.clear();
// };

// /**
//  * تنظیم timeout جدید
//  */
// api.setTimeout = (timeout) => {
//   api.defaults.timeout = timeout;
// };

// /**
//  * دریافت وضعیت درخواست‌های در حال اجرا
//  */
// api.getPendingRequestsCount = () => pendingRequests.size;

// /**
//  * ریست interceptorها (برای تست)
//  */
// api.resetInterceptors = () => {
//   api.interceptors.request.handlers = [];
//   api.interceptors.response.handlers = [];
// };

// // ==================== CUSTOM METHODS ====================

// /**
//  * درخواست GET با retry خودکار
//  */
// api.getWithRetry = async (url, config = {}, maxRetries = 3) => {
//   let lastError;
  
//   for (let i = 0; i < maxRetries; i++) {
//     try {
//       return await api.get(url, config);
//     } catch (error) {
//       lastError = error;
      
//       // فقط برای خطاهای خاص retry کنیم
//       if (error.response?.status >= 500 || !error.response) {
//         await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1))); // exponential backoff
//         continue;
//       }
//       break;
//     }
//   }
  
//   throw lastError;
// };

// /**
//  * آپلود فایل با progress tracking
//  */
// api.uploadFile = (url, file, data = {}, onProgress = null) => {
//   const formData = new FormData();
//   formData.append('file', file);
  
//   // اضافه کردن فیلدهای اضافی
//   Object.entries(data).forEach(([key, value]) => {
//     formData.append(key, value);
//   });
  
//   const config = {
//     onUploadProgress: (progressEvent) => {
//       if (onProgress) {
//         const percentCompleted = Math.round(
//           (progressEvent.loaded * 100) / progressEvent.total
//         );
//         onProgress(percentCompleted);
//       }
//     }
//   };
  
//   return api.post(url, formData, config);
// };

// export default api;




// ---------------------- فایل api-config.js جداگانه (اختیاری): -------------------
// // api-config.js
// export const API_CONFIG = {
//   baseURL: process.env.REACT_APP_API_URL || 'https://app.autoyad.ir',
//   timeout: 30000,
//   retryCount: 3,
//   retryDelay: 1000,
  
//   // endpoints
//   endpoints: {
//     auth: {
//       login: '/api/Authenticate/login',
//       logout: '/api/Authenticate/logout',
//       status: '/api/Authenticate/auth-status'
//     },
//     cars: {
//       create: '/api/Cars',
//       list: '/api/Cars',
//       detail: (id) => `/api/Cars/${id}`
//     }
//   },
  
//   // error messages
//   messages: {
//     networkError: 'اتصال اینترنت خود را بررسی کنید',
//     serverError: 'خطای سرور. لطفاً بعداً تلاش کنید.',
//     timeout: 'سرور پاسخ نمی‌دهد',
//     unauthorized: 'لطفاً وارد شوید'
//   }
// };
//---------------------- 🚀 استفاده در پروژه:
// import api from './services/api';
// import { API_CONFIG } from './services/api-config';

// // استفاده معمول
// api.post(API_CONFIG.endpoints.auth.login, {
//   username: '...',
//   password: '...'
// });

// // آپلود فایل با progress
// api.uploadFile(
//   API_CONFIG.endpoints.cars.create,
//   file,
//   { title: 'خودروی تست' },
//   (progress) => {
//     console.log(`آپلود: ${progress}%`);
//   }
// );

// // GET با retry
// api.getWithRetry(API_CONFIG.endpoints.cars.list, {}, 3);